/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate Relative Synonymous Codon Usage (RSCU) for a coding sequence.`)
};

const es_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula el Uso Relativo de Codones Sinónimos (RSCU) para una secuencia codificante.`)
};

const de_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie die Relative Synonyme Codon-Nutzung (RSCU) für eine Kodierungssequenz.`)
};

const nl_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken Relative Synonymous Codon Usage (RSCU) voor een coderende sequentie.`)
};

const fr_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez l'usage relatif des codons synonymes (RSCU) pour une séquence codante.`)
};

const it_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola l'uso relativo dei codoni sinonimi (RSCU) per una sequenza codificante.`)
};

const pt_br2_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o Uso Relativo de Códons Sinônimos (RSCU) de uma sequência codificante.`)
};

const pt_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o Uso Relativo de Codões Sinónimos (RSCU) para uma sequência codificante.`)
};

const ja_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード配列の相対同義コドン使用頻度 (RSCU) を計算します。`)
};

const zh_rscu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算编码序列的相对同义密码子使用度（RSCU）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_tool_description", locale)
	if (locale === "en") return en_rscu_tool_description(inputs)
	if (locale === "es") return es_rscu_tool_description(inputs)
	if (locale === "de") return de_rscu_tool_description(inputs)
	if (locale === "nl") return nl_rscu_tool_description(inputs)
	if (locale === "fr") return fr_rscu_tool_description(inputs)
	if (locale === "it") return it_rscu_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_tool_description(inputs)
	if (locale === "pt") return pt_rscu_tool_description(inputs)
	if (locale === "ja") return ja_rscu_tool_description(inputs)
	return zh_rscu_tool_description(inputs)
};